module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[77]198.7c8c4fa.woff2";